import React from "react";
import styled from "styled-components";
import OptionDiv from "./OptionDiv";
import BlackLayer from "../BlackLayer";
// const data = {
//   header: {
//     img: "",
//     text: "",
//     event: "",
//   },
//   body: {

//   }
const IdCardFloatLayer = props => {
  const { data } = props;

  return (
    <BlackLayer>
      <BottomSheet>
        <Header onClick={data.header.event}>
          <HeaderText>{data.header.text}</HeaderText>
          <img
            src={data.header.img}
            style={{ width: "16px", height: "16px" }}
          />
        </Header>
        <Body>
          {data.body.contents.map((item, i) => (
            <OptionDiv data={item} key={"optionDiv" + i} />
          ))}
        </Body>
      </BottomSheet>
    </BlackLayer>
  );
};

const BottomSheet = styled.div`
  width: 100%;
  flex-grow: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: stretch;
  padding: 16px 0 0;
  box-shadow: 0 -8px 40px 0 rgba(0, 0, 0, 0.15);
  background-color: #fff;
  position: fixed;
  bottom: 0;
  border-radius: 16px 16px 0px 0px;
`;

const Header = styled.div`
  align-self: stretch;
  flex-grow: 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
  padding: 8px 16px;
`;

const HeaderText = styled.div`
  flex-grow: 1;
  font-family: Pretendard;
  font-size: 18px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.44;
  letter-spacing: -0.36px;
  text-align: left;
  color: #333;
`;

const Body = styled.div`
  height: 128px;
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  padding: 0 20px 24px;
`;

export default IdCardFloatLayer;
